module.exports = __webpack_public_path__ + "img/UTS-Icon1_os.fbe430cf.png";